import React from 'react'
import XYFrame from 'semiotic/lib/XYFrame'
import { format } from 'd3-format'
import { select } from 'd3-selection'

import styles from './index.module.css'

const d3 = { select }

const tooltipStyles = {
  header: {
    fontWeight: 'bold',
    borderBottom: 'thin solid black',
    marginBottom: '10px',
    textAlign: 'center'
  },
  lineItem: { position: 'relative', display: 'block', textAlign: 'left' },
  title: { display: 'inline-block', margin: '0 5px 0 15px' },
  value: { display: 'inline-block', fontWeight: 'bold', margin: '0' },
  wrapper: {
    background: 'rgba(255,255,255,0.85)',
    minWidth: 'max-content',
    whiteSpace: 'nowrap'
  }
}

const frameProps = {
  margin: { left: 80, bottom: 80, right: 30, top: 16 },
  xAccessor: 'year',
  yAccessor: 'realMedianSalesPrice',
  yExtent: [0, 600000],
  showLinePoints: true,
  title: <text textAnchor="middle" />,
  hoverAnnotation: [
    { type: 'x', disable: ['connector', 'note'] },
    { type: 'frame-hover' },
    {
      type: 'vertical-points',
      threshold: 0.1,
      r: function() {
        return 5
      }
    }
  ]
}

export default props => {
  const { lines, colorScale, width, tooltipHeaderPrefix } = props
  let tickCount = lines[0].coordinates.length
  if (width <= 600) tickCount = Math.floor(lines[0].coordinates.length / 2)
  frameProps.lines = lines

  frameProps.size = [width, 400]

  frameProps.axes = [
    {
      orient: 'left',
      label: '',
      tickFormat: function(e) {
        return `$${e / 1e3}k`
      },
      baseline: false
    },
    {
      orient: 'bottom',
      tickLineGenerator: () => {},
      tickFormat: format('.0f'),
      ticks: tickCount,
      label: '',
      rotate: -45,
      baseline: false
    }
  ]

  frameProps.lineStyle = (d, i) => {
    const key = d.title
    if (key === 'Florida') {
      return {
        strokeDasharray: '4, 12',
        stroke: colorScale[key],
        strokeWidth: 2,
        fill: 'none'
      }
    }
    return { stroke: colorScale[key], strokeWidth: 2, fill: 'none' }
  }

  frameProps.pointStyle = (d, i) => {
    let key
    if (d && d.parentLine) key = d.parentLine.title
    if (key === 'Florida') {
      return {
        fill: colorScale[key],
        stroke: colorScale[key],
        strokeWidth: '2px'
      }
    }
    return {
      stroke: colorScale[key],
      fill: colorScale[key],
      strokeWidth: '2px'
    }
  }

  frameProps.tooltipContent = d => {
    const points = lines
      .map(point => {
        return {
          id: point.title,
          color: point.color,
          data: point.coordinates.find(coord => {
            // Search the lines for a similar x value for vertical shared tooltip
            // Can implement a 'close enough' conditional here too (fuzzy equality)
            return coord[frameProps.xAccessor] === d[frameProps.xAccessor]
          })
        }
      })
      .sort((a, b) => b[frameProps.yAccessor] - a[frameProps.yAccessor])

    const returnArray = [
      <div key={'header_multi'} style={tooltipStyles.header}>
        {`${tooltipHeaderPrefix} ${d[frameProps.xAccessor]}`}
      </div>
    ]

    points.forEach((point, i) => {
      const title = point.id;
      const valueString = `${format('$,.0f')(point.data[frameProps.yAccessor])}  (${format(',.0f')(point.data['numberofSales'])} sales)`

      returnArray.push([
        <div key={`tooltip_line_${i}`} style={tooltipStyles.lineItem}>
          <p
            key={`tooltip_color_${i}`}
            style={{
              width: '10px',
              height: '10px',
              backgroundColor: point.color,
              display: 'inline-block',
              position: 'absolute',
              top: '8px',
              left: '0',
              margin: '0'
            }}
          />
          <p
            key={`tooltip_p_${i}`}
            style={tooltipStyles.title}
          >{`${title} =`}</p>
          <p key={`tooltip_p_val_${i}`} style={tooltipStyles.value}>
            {valueString}
          </p>
        </div>
      ])
    })

    return (
      <div className="tooltip-content" style={tooltipStyles.wrapper}>
        {returnArray}
      </div>
    )
  }

  frameProps.customHoverBehavior = d => {
    if (d && d.x) {
      console.log('d from customHoverBehavior', d)
      const halfLine = 2008
      if (d.x > halfLine) {
        // console.log(`${d.x} is on the right side`)
        d3.select('.tooltip-content').style('transform', 'translate(-254px)')
      } else {
        // console.log(`${d.x} is on the left side`)
        d3.select('.tooltip-content').style('transform', 'translate(0px)')
      }
    }
  }

  return <XYFrame className={styles.lineChart} {...frameProps} />
}
